import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "userCenter" }
const _hoisted_2 = { style: {"place-items":"center","display":"grid"} }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "nickName" }

import { useRouter } from "vue-router";
import {
  PostCommentControllerService,
  PostCommentQueryRequest,
  PostCommentVO,
  PostControllerService,
  PostQueryRequest,
  PostVO,
  UserControllerService,
  UserVO,
  WriteUpControllerService,
  WriteUpQueryRequest,
  WriteUpVO,
} from "../generated";
import { onMounted, ref } from "vue";
import moment from "moment";
import message from "@arco-design/web-vue/es/message";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserCenterView',
  setup(__props) {

const router = useRouter();
const searchParams = ref({
  post: {
    current: 0,
    pageSize: 10,
  } as PostQueryRequest,
  postComment: {
    current: 0,
    pageSize: 10,
  } as PostCommentQueryRequest,
  writeUp: {
    current: 0,
    pageSize: 10,
  } as WriteUpQueryRequest,
});
const dataList = ref({
  post: [] as PostVO[],
  postComment: [] as PostCommentVO[],
  writeUp: [] as WriteUpVO[],
});
const totalList = ref({
  postTotal: 0,
  commentTotal: 0,
  writeUpTotal: 0,
});
// 获取用户信息并且进行处理
let currUser = ref<UserVO>({});
const loadData = async () => {
  //拿到当前用户
  const res = await UserControllerService.getUserVoByIdUsingGet(
    router.currentRoute.value.params.id as any
  );
  if (res.code === 0) {
    currUser.value = res.data as any;
  } else {
    message.error("加载失败！ " + res.message);
  }
  //获取当前用户发表过的帖子
  const postRes = await PostControllerService.listMyPostVoByPageUsingPost(
    searchParams.value.post
  );
  if (postRes.code === 0) {
    dataList.value.post = postRes.data.records as any;
    totalList.value.postTotal = postRes.data.total as any;
  } else {
    message.error("加载失败！ " + postRes.message);
  }
  //获取当前用户发表的评论
  const postCommentRes =
    await PostCommentControllerService.listMyPostCommentVoByPageUsingPost(
      searchParams.value.postComment
    );
  if (postCommentRes.code === 0) {
    dataList.value.postComment = postCommentRes.data.records as any;
    totalList.value.commentTotal = postCommentRes.data.total as any;
  } else {
    message.error("加载失败！ " + postCommentRes.message);
  }
  //获取当前用户发表的题解
  const writeUpRes =
    await WriteUpControllerService.listMyWriteUpVoByPageUsingPost(
      searchParams.value.writeUp
    );
  if (writeUpRes.code === 0) {
    dataList.value.writeUp = writeUpRes.data.records as any;
    totalList.value.writeUpTotal = writeUpRes.data.total as any;
  } else {
    message.error("加载失败！ " + writeUpRes.message);
  }
};
onMounted(() => {
  loadData();
});

const toEditDetail = (data: any) => {
  router.push({
    path: `/user/edit/${data?.userId}`,
  });
};

const isMadelVisible = ref(false);
const isConfirmModalVisible = ref(false);
const deleteAccount = async () => {
  const res = await UserControllerService.deleteUserUsingPost({
    id: currUser.value.userId as any,
  });
  if (res.code === 0) {
    message.success("账号注销成功，正在跳转到首页...");
    setTimeout(() => {
      router.push({ path: "/" });
    }, 1500);
  } else {
    message.error("账号注销失败！ " + res.message);
  }
  isConfirmModalVisible.value = false;
};
const deletePost = async (post: PostVO) => {
  const res = await PostControllerService.deletePostUsingPost({
    id: post.postId as any,
  });
  if (res.code === 0) {
    // 更新页面
    message.success("删除题解成功！");
    await loadData();
  } else {
    message.error("删除题解失败！ " + res.message);
  }
  isConfirmModalVisible.value = false;
};
const deletePostComment = async (postComment: PostCommentVO) => {
  const res = await PostCommentControllerService.deletePostCommentUsingPost({
    id: postComment.postCommentId as any,
  });
  if (res.code === 0) {
    // 更新页面
    message.success("删除题解成功！");
    await loadData();
  } else {
    message.error("删除题解失败！ " + res.message);
  }
  isConfirmModalVisible.value = false;
};
const deleteWriteUp = async (writeUp: WriteUpVO) => {
  const res = await WriteUpControllerService.deleteWriteUpUsingPost({
    id: writeUp.writeUpId as any,
  });
  if (res.code === 0) {
    // 更新页面
    message.success("删除题解成功！");
    await loadData();
  } else {
    message.error("删除题解失败！ " + res.message);
  }
  isConfirmModalVisible.value = false;
};

const toReview = () => {
  router.push({
    path: "/review",
    replace: true,
  });
};

// 表格列定义
const postColumns = [
  { title: "标题", dataIndex: "title" },
  { title: "标签", slotName: "tag" },
  { title: "发布时间", slotName: "createTime" },
  { title: "审核状态", slotName: "reviewStatus" },
  { title: "操作", slotName: "optional" },
];

const postCommentColumns = [
  { title: "内容", dataIndex: "content" },
  { title: "发布时间", slotName: "createTime" },
  { title: "审核状态", slotName: "reviewStatus" },
  { title: "操作", slotName: "optional" },
];

const writeUpColumns = [
  { title: "标题", dataIndex: "title" },
  { title: "标签", slotName: "tag" },
  { title: "发布时间", slotName: "createTime" },
  { title: "审核状态", slotName: "reviewStatus" },
  { title: "操作", slotName: "optional" },
];

// 分页处理器
const onPostPageChange = (page: number) => {
  searchParams.value.post = {
    ...searchParams.value.post,
    current: page,
  } as any;
};
const onPostCommentPageChange = (page: number) => {
  searchParams.value.postComment = {
    ...searchParams.value.postComment,
    current: page,
  } as any;
};
const onWriteUpPageChange = (page: number) => {
  searchParams.value.writeUp = {
    ...searchParams.value.writeUp,
    current: page,
  } as any;
};

return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_layout, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_layout_header, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { class: "infoCard" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, { class: "userInfo" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      span: 3,
                      style: {"min-height":"100px"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_a_avatar, { size: 100 }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                src: _unref(currUser).userAvatar,
                                alt: "avatar"
                              }, null, 8, _hoisted_3)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 1 }),
                    _createVNode(_component_a_col, {
                      span: 20,
                      style: {"min-height":"100px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(currUser).userName), 1)
                          ]),
                          _: 1
                        }),
                        _cache[12] || (_cache[12] = _createElementVNode("div", { style: {"margin":"16px 0"} }, null, -1)),
                        _createVNode(_component_a_row, { class: "userProfile" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, _toDisplayString(_unref(currUser).userProfile ?? "这是默认简介"), 1)
                          ]),
                          _: 1
                        }),
                        _cache[13] || (_cache[13] = _createElementVNode("div", { style: {"margin":"16px 0"} }, null, -1)),
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_tag, {
                              bordered: "",
                              class: "extraInfo",
                              color: "orangered"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("role : " + _toDisplayString(_unref(currUser).userRole), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_tag, {
                              bordered: "",
                              class: "extraInfo",
                              color: "gray"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("uid : " + _toDisplayString(_unref(currUser).userId), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _cache[19] || (_cache[19] = _createElementVNode("div", { style: {"margin-top":"10px"} }, null, -1)),
                _createVNode(_component_a_row, { class: "userStatistics" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          class: "userButton",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (toEditDetail(_unref(currUser))))
                        }, {
                          default: _withCtx(() => _cache[14] || (_cache[14] = [
                            _createTextVNode("修改资料 ")
                          ])),
                          _: 1
                        }),
                        (_unref(currUser)?.userRole === 'user')
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 0,
                              class: "userButton",
                              onClick: _cache[1] || (_cache[1] = 
                  () => {
                    isMadelVisible.value = true;
                  }
                ),
                              status: "danger"
                            }, {
                              default: _withCtx(() => _cache[15] || (_cache[15] = [
                                _createTextVNode("注销账号 ")
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_a_modal, {
                          visible: isMadelVisible.value,
                          onOk: deleteAccount,
                          onCancel: _cache[2] || (_cache[2] = 
                  () => {
                    isMadelVisible.value = false;
                  }
                ),
                          unmountOnClose: ""
                        }, {
                          title: _withCtx(() => _cache[16] || (_cache[16] = [
                            _createTextVNode(" 危险操作！ ")
                          ])),
                          default: _withCtx(() => [
                            _cache[17] || (_cache[17] = _createElementVNode("div", null, " 注销账号是个危险操作，注销后您将无法通过此账号进行登录！请问您是否确认注销？ ", -1))
                          ]),
                          _: 1
                        }, 8, ["visible"]),
                        (_unref(currUser)?.userRole === 'admin')
                          ? (_openBlock(), _createBlock(_component_a_badge, {
                              key: 1,
                              count: 0
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  class: "userButton",
                                  onClick: toReview
                                }, {
                                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                                    _createTextVNode("审核事项 ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_layout, { class: "content" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_layout, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_layout_content, { class: "post-show" }, {
                  default: _withCtx(() => [
                    _cache[41] || (_cache[41] = _createElementVNode("h2", null, "我发布的", -1)),
                    _createVNode(_component_a_tabs, { "default-active-key": "0" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_tab_pane, {
                          key: "0",
                          title: "帖子"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_space, null, {
                              default: _withCtx(() => [
                                _cache[20] || (_cache[20] = _createTextVNode("每页帖子数量 ")),
                                _createVNode(_component_a_input_number, {
                                  modelValue: searchParams.value.post.pageSize,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchParams.value.post.pageSize) = $event)),
                                  min: "1",
                                  placeholder: "每页帖子数量",
                                  size: "small",
                                  style: {"width":"200px"}
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_divider, { size: 0 }),
                            _createVNode(_component_a_table, {
                              columns: postColumns,
                              data: dataList.value.post,
                              pagination: {
                    showTotal: true,
                    pageSize: searchParams.value.post.pageSize,
                    current: searchParams.value.post.current,
                    total: totalList.value.postTotal,
                  },
                              onPageChange: onPostPageChange
                            }, {
                              tag: _withCtx(({ record }) => [
                                _createVNode(_component_a_space, { wrap: "" }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.tag, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_a_tag, {
                                        key: index,
                                        color: "green"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              createTime: _withCtx(({ record }) => [
                                _createVNode(_component_a_space, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD HH:mm:ss")), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              reviewStatus: _withCtx(({ record }) => [
                                _createVNode(_component_a_space, null, {
                                  default: _withCtx(() => [
                                    (record.reviewStatus === 1)
                                      ? (_openBlock(), _createBlock(_component_a_tag, {
                                          key: 0,
                                          color: "green"
                                        }, {
                                          default: _withCtx(() => _cache[21] || (_cache[21] = [
                                            _createTextVNode("已通过")
                                          ])),
                                          _: 1
                                        }))
                                      : (record.reviewStatus === 2)
                                        ? (_openBlock(), _createBlock(_component_a_tag, {
                                            key: 1,
                                            color: "red"
                                          }, {
                                            default: _withCtx(() => _cache[22] || (_cache[22] = [
                                              _createTextVNode("已退回")
                                            ])),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createBlock(_component_a_tag, {
                                            key: 2,
                                            color: "gray"
                                          }, {
                                            default: _withCtx(() => _cache[23] || (_cache[23] = [
                                              _createTextVNode("待审核")
                                            ])),
                                            _: 1
                                          }))
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              optional: _withCtx(({ record }) => [
                                _createVNode(_component_a_space, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_button, {
                                      type: "primary",
                                      status: "danger",
                                      onClick: _cache[4] || (_cache[4] = 
                          () => {
                            isConfirmModalVisible.value = true;
                          }
                        )
                                    }, {
                                      default: _withCtx(() => _cache[24] || (_cache[24] = [
                                        _createTextVNode("删除")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_modal, {
                                      visible: isConfirmModalVisible.value,
                                      onOk: ($event: any) => (deletePost(record)),
                                      onCancel: _cache[5] || (_cache[5] = 
                          () => {
                            isConfirmModalVisible.value = true;
                          }
                        ),
                                      unmountOnClose: ""
                                    }, {
                                      title: _withCtx(() => _cache[25] || (_cache[25] = [
                                        _createTextVNode(" 危险操作！ ")
                                      ])),
                                      default: _withCtx(() => [
                                        _cache[26] || (_cache[26] = _createElementVNode("div", null, "确认删除该帖子？", -1))
                                      ]),
                                      _: 2
                                    }, 1032, ["visible", "onOk"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 1
                            }, 8, ["data", "pagination"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_tab_pane, {
                          key: "1",
                          title: "评论"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_space, null, {
                              default: _withCtx(() => [
                                _cache[27] || (_cache[27] = _createTextVNode("每页评论数量 ")),
                                _createVNode(_component_a_input_number, {
                                  modelValue: searchParams.value.postComment.pageSize,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((searchParams.value.postComment.pageSize) = $event)),
                                  min: "1",
                                  placeholder: "每页评论数量",
                                  size: "small",
                                  style: {"width":"200px"}
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_divider, { size: 0 }),
                            _createVNode(_component_a_table, {
                              columns: postCommentColumns,
                              data: dataList.value.postComment,
                              pagination: {
                    showTotal: true,
                    pageSize: searchParams.value.postComment.pageSize,
                    current: searchParams.value.postComment.current,
                    total: totalList.value.commentTotal,
                  },
                              onPageChange: onPostCommentPageChange
                            }, {
                              postCommentId: _withCtx(({ record }) => [
                                _createVNode(_component_a_space, { wrap: "" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(record.postCommentId), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              createTime: _withCtx(({ record }) => [
                                _createVNode(_component_a_space, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD HH:mm:ss")), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              reviewStatus: _withCtx(({ record }) => [
                                _createVNode(_component_a_space, null, {
                                  default: _withCtx(() => [
                                    (record.reviewStatus === 1)
                                      ? (_openBlock(), _createBlock(_component_a_tag, {
                                          key: 0,
                                          color: "green"
                                        }, {
                                          default: _withCtx(() => _cache[28] || (_cache[28] = [
                                            _createTextVNode("已通过")
                                          ])),
                                          _: 1
                                        }))
                                      : (record.reviewStatus === 2)
                                        ? (_openBlock(), _createBlock(_component_a_tag, {
                                            key: 1,
                                            color: "red"
                                          }, {
                                            default: _withCtx(() => _cache[29] || (_cache[29] = [
                                              _createTextVNode("已退回")
                                            ])),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createBlock(_component_a_tag, {
                                            key: 2,
                                            color: "gray"
                                          }, {
                                            default: _withCtx(() => _cache[30] || (_cache[30] = [
                                              _createTextVNode("待审核")
                                            ])),
                                            _: 1
                                          }))
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              optional: _withCtx(({ record }) => [
                                _createVNode(_component_a_space, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_button, {
                                      type: "primary",
                                      status: "danger",
                                      onClick: _cache[7] || (_cache[7] = 
                          () => {
                            isConfirmModalVisible.value = true;
                          }
                        )
                                    }, {
                                      default: _withCtx(() => _cache[31] || (_cache[31] = [
                                        _createTextVNode("删除")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_modal, {
                                      visible: isConfirmModalVisible.value,
                                      onOk: ($event: any) => (deletePostComment(record)),
                                      onCancel: _cache[8] || (_cache[8] = 
                          () => {
                            isConfirmModalVisible.value = true;
                          }
                        ),
                                      unmountOnClose: ""
                                    }, {
                                      title: _withCtx(() => _cache[32] || (_cache[32] = [
                                        _createTextVNode(" 危险操作！ ")
                                      ])),
                                      default: _withCtx(() => [
                                        _cache[33] || (_cache[33] = _createElementVNode("div", null, "确认删除该评论？", -1))
                                      ]),
                                      _: 2
                                    }, 1032, ["visible", "onOk"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 1
                            }, 8, ["data", "pagination"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_tab_pane, {
                          key: "2",
                          title: "题解"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_space, null, {
                              default: _withCtx(() => [
                                _cache[34] || (_cache[34] = _createTextVNode("每页题解数量 ")),
                                _createVNode(_component_a_input_number, {
                                  modelValue: searchParams.value.writeUp.pageSize,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((searchParams.value.writeUp.pageSize) = $event)),
                                  min: "1",
                                  placeholder: "每页题解数量",
                                  size: "small",
                                  style: {"width":"200px"}
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_divider, { size: 0 }),
                            _createVNode(_component_a_table, {
                              columns: writeUpColumns,
                              data: dataList.value.writeUp,
                              pagination: {
                    showTotal: true,
                    pageSize: searchParams.value.writeUp.pageSize,
                    current: searchParams.value.writeUp.current,
                    total: totalList.value.writeUpTotal,
                  },
                              onPageChange: onWriteUpPageChange
                            }, {
                              writeUpId: _withCtx(({ record }) => [
                                _createVNode(_component_a_space, { wrap: "" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(record.writeUpId), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              tag: _withCtx(({ record }) => [
                                _createVNode(_component_a_space, { wrap: "" }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.tag, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_a_tag, {
                                        key: index,
                                        color: "green"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              createTime: _withCtx(({ record }) => [
                                _createVNode(_component_a_space, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD HH:mm:ss")), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              reviewStatus: _withCtx(({ record }) => [
                                _createVNode(_component_a_space, null, {
                                  default: _withCtx(() => [
                                    (record.reviewStatus === 1)
                                      ? (_openBlock(), _createBlock(_component_a_tag, {
                                          key: 0,
                                          color: "green"
                                        }, {
                                          default: _withCtx(() => _cache[35] || (_cache[35] = [
                                            _createTextVNode("已通过")
                                          ])),
                                          _: 1
                                        }))
                                      : (record.reviewStatus === 2)
                                        ? (_openBlock(), _createBlock(_component_a_tag, {
                                            key: 1,
                                            color: "red"
                                          }, {
                                            default: _withCtx(() => _cache[36] || (_cache[36] = [
                                              _createTextVNode("已退回")
                                            ])),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createBlock(_component_a_tag, {
                                            key: 2,
                                            color: "gray"
                                          }, {
                                            default: _withCtx(() => _cache[37] || (_cache[37] = [
                                              _createTextVNode("待审核")
                                            ])),
                                            _: 1
                                          }))
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              optional: _withCtx(({ record }) => [
                                _createVNode(_component_a_space, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_button, {
                                      type: "primary",
                                      status: "danger",
                                      onClick: _cache[10] || (_cache[10] = 
                          () => {
                            isConfirmModalVisible.value = true;
                          }
                        )
                                    }, {
                                      default: _withCtx(() => _cache[38] || (_cache[38] = [
                                        _createTextVNode("删除")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_modal, {
                                      visible: isConfirmModalVisible.value,
                                      onOk: ($event: any) => (deleteWriteUp(record)),
                                      onCancel: _cache[11] || (_cache[11] = 
                          () => {
                            isConfirmModalVisible.value = true;
                          }
                        ),
                                      unmountOnClose: ""
                                    }, {
                                      title: _withCtx(() => _cache[39] || (_cache[39] = [
                                        _createTextVNode(" 危险操作！ ")
                                      ])),
                                      default: _withCtx(() => [
                                        _cache[40] || (_cache[40] = _createElementVNode("div", null, "确认删除该题解？", -1))
                                      ]),
                                      _: 2
                                    }, 1032, ["visible", "onOk"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 1
                            }, 8, ["data", "pagination"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})